import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { AuthLoginService } from 'src/app/page/auth-page/service/auth-login.service';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { PasswordResetService } from './service/password-reset.service';
import { LabelsService } from 'src/app/util/services/labels/labels.service';
import { Router, NavigationEnd } from '@angular/router';
import { NotificationService } from 'src/app/services/notification/notification.service';
import { CommonModule } from '@angular/common';
import { DotBounceLoadingEffectModule } from 'src/app/page_component_item/dot-bounce-loading-effect/dot-bounce-loading-effect.module';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { LabelsInterface } from 'src/app/util/services/labels/data/label.inteface';

@Component({
	standalone: true,
	imports: [CommonModule, DotBounceLoadingEffectModule, FaIconComponent],
	selector: 'pcp-password-reset',
	templateUrl: './password-reset.component.html',
	styleUrls: ['./password-reset.component.scss'],
})
export class PasswordResetComponent implements OnInit {
	@Input()
	email: string;

	@Input()
	token: string;

	@Output()
	passwordSubmitedEmitter = new EventEmitter();

	faEye = faEye;
	faEyeSlash = faEyeSlash;

	isLoggedIn: boolean;
	isUpdatingPassword = false;

	securityMeterPercentage = 0;
	securityMeterColor = 'danger';
	securityMeterText = '';
	canSubmitNewPassword = false;
	isConfirmEqualNewPassword = true;

	oldPasswordViewType = 'password';
	newPasswordViewType = 'password';
	confirmNewPasswordViewtype = 'password';

	oldPassword = '';
	newPassword = '';
	confirmNewPassword = '';
	emailNullorEmpty = false;

	alertMessage = '';

	labels: LabelsInterface = {
		lbl_geral_senha_atual: 'Current Password',
		lbl_geral_senha_nova: 'New Password',
		lbl_confirma_senha: 'Confirm your new password',
		lbl_update_password: 'Update password',
		lbl_tools_complexidade_senha: 'Password Strength',
		lbl_tools_fraca: 'Weak',
		lbl_tools_media: 'Medium',
		lbl_tools_forte: 'Strong',
		lbl_new_password_tip:
			'Remember, your password need to be at least 8 characters long, has a capital letter, a number or a special character',
		lbl_password_confirmation_wrong: 'Password confirmation is wrong',
		lbl_geral_senha_alterada_usuario: 'Password Changed by the user',
		lbl_password_not_strong: 'Password not strong enough',
		lbl_old_password_wrong: 'Old password may be wrong',
		lbl_choose_different_password: 'Choose a different password than your old ones',
	};

	constructor(
		private PasswordResetService: PasswordResetService,
		private AuthLoginService: AuthLoginService,
		private LabelsService: LabelsService,
		private Router: Router,
		private Notification: NotificationService
	) {}

	isLoadingLabels = true;

	ngOnInit(): void {
		this.LabelsService.getLabels().subscribe((labels) => {
			this.labels = labels;
			this.isLoadingLabels = false;
		});

		this.alertMessage = this.labels.lbl_new_password_tip;
		this.isLoggedIn = this.AuthLoginService.isLoggedIn();

		if (this.email == '' || this.email == '' || this.email == undefined) {
			this.emailNullorEmpty = true;
		}

		if (this.isLoggedIn) {
			this.LabelsService.getLabels().subscribe((labels) => {
				this.labels = labels;
			});
		}
	}

	calculateNewPasswordStrength() {
		let newSecurityMeterPercentage = 0;
		const upperCaseRegex = new RegExp('[A-Z]');
		const lowerCaseRegex = new RegExp('[a-z]');
		const numberRegex = new RegExp(String.raw`\d`);
		const specialRegex = new RegExp('(?=.*[!@#\$%\^&\*])');

		upperCaseRegex.test(this.newPassword) ? (newSecurityMeterPercentage += 20) : null;
		lowerCaseRegex.test(this.newPassword) ? (newSecurityMeterPercentage += 20) : null;
		numberRegex.test(this.newPassword) ? (newSecurityMeterPercentage += 20) : null;
		specialRegex.test(this.newPassword) ? (newSecurityMeterPercentage += 20) : null;
		this.newPassword.length >= 8 ? (newSecurityMeterPercentage += 20) : null;

		while (this.securityMeterPercentage != newSecurityMeterPercentage) {
			if (this.securityMeterPercentage > newSecurityMeterPercentage) this.securityMeterPercentage--;
			else if (this.securityMeterPercentage < newSecurityMeterPercentage) this.securityMeterPercentage++;
		}

		if (this.newPassword.length < 8) {
			this.canSubmitNewPassword = false;
			this.securityMeterColor = 'danger';
			this.securityMeterText = this.labels.lbl_tools_fraca;
		} else {
			if (this.securityMeterPercentage <= 20) {
				this.canSubmitNewPassword = false;
				this.securityMeterText = '';
			} else if (this.securityMeterPercentage < 60) {
				this.canSubmitNewPassword = false;
				this.securityMeterColor = 'danger';
				this.securityMeterText = this.labels.lbl_tools_fraca;
			} else if (this.securityMeterPercentage >= 60 && this.securityMeterPercentage < 80) {
				this.canSubmitNewPassword = true;
				this.securityMeterColor = 'warning';
				this.securityMeterText = this.labels.lbl_tools_media;
			} else if (this.securityMeterPercentage >= 80) {
				this.canSubmitNewPassword = true;
				this.securityMeterColor = 'success';
				this.securityMeterText = this.labels.lbl_tools_forte;
			}
		}
	}

	confirmEqualNewPassword(): void {
		this.isConfirmEqualNewPassword = this.newPassword == this.confirmNewPassword;
	}

	submitNewPassword() {
		if (!this.isConfirmEqualNewPassword) {
			this.alertMessage = this.labels.lbl_password_confirmation_wrong;
		} else if (this.canSubmitNewPassword && this.isLoggedIn) {
			this.isUpdatingPassword = true;
			this.AuthLoginService.generateSessionToken(this.email, this.oldPassword).subscribe(
				() => {
					this.PasswordResetService.submitNewPassword(
						this.AuthLoginService.getSessionToken(),
						this.email,
						this.newPassword
					).subscribe(
						() => {
							this.alertMessage = this.labels.lbl_geral_senha_alterada_usuario;
							this.oldPassword = '';
							this.newPassword = '';
							this.confirmNewPassword = '';
							this.canSubmitNewPassword = false;
							this.securityMeterColor = 'danger';
							this.securityMeterPercentage = 0;
							this.isUpdatingPassword = false;
							this.emitPasswordSubmited();
						},
						(error) => {
							this.Notification.setNotificationMessage(this.labels.lbl_choose_different_password);
							this.alertMessage = this.labels.lbl_new_password_tip;
							this.isUpdatingPassword = false;
						}
					);
				},
				(error) => {
					this.alertMessage = this.labels.lbl_old_password_wrong;
				}
			);
		} else {
			this.alertMessage = this.labels.lbl_password_not_strong;
		}
	}

	recoverPassword() {
		if (!this.isConfirmEqualNewPassword) {
			this.Notification.setNotificationMessage(this.labels.lbl_password_confirmation_wrong);
		} else if (this.canSubmitNewPassword && !this.isLoggedIn && !this.emailNullorEmpty) {
			this.isUpdatingPassword = true;
			this.PasswordResetService.recoverPassword(this.email, this.newPassword).subscribe(
				() => {
					this.alertMessage = this.labels.lbl_geral_senha_alterada_usuario;
					this.newPassword = '';
					this.confirmNewPassword = '';
					this.canSubmitNewPassword = false;
					this.securityMeterColor = 'danger';
					this.securityMeterPercentage = 0;
					this.isUpdatingPassword = false;
					this.emitPasswordSubmited();
					this.Notification.setNotificationMessage('The password has been changed successfully');
					localStorage.removeItem('pwResetToken');
					this.Router.navigate(['/login']);
				},
				(error) => {
					this.Notification.setNotificationMessage(this.labels.lbl_choose_different_password);
					this.alertMessage = this.labels.lbl_new_password_tip;
					this.isUpdatingPassword = false;
				}
			);
		} else {
			this.Notification.setNotificationMessage(this.labels.lbl_password_not_strong);
			this.alertMessage = this.labels.lbl_new_password_tip;
			this.isUpdatingPassword = false;
		}
	}

	emitPasswordSubmited(): void {
		this.passwordSubmitedEmitter.emit('true');
	}
}
